import React from "react";
import { Typography } from "@sumprio/ui";

const REQUIRED_ASTERISK_STYLE: React.CSSProperties = {
  color: "var(--color-text-input-required, var(--color-red-500, #f04438))",
};

type TypographyLabelProps = Pick<
  React.ComponentProps<typeof Typography>,
  "variant" | "bodySize" | "bodyWeight" | "color" | "className"
>;

export interface RequiredFieldLabelProps extends TypographyLabelProps {
  id?: string;
  label: string;
  required?: boolean;
}

export function RequiredFieldLabel({
  id,
  label,
  required = true,
  variant = "body",
  bodySize = "xs",
  bodyWeight = "regular",
  color,
  className,
}: RequiredFieldLabelProps) {
  return (
    <Typography
      id={id}
      variant={variant}
      bodySize={bodySize}
      bodyWeight={bodyWeight}
      color={color}
      className={className}
    >
      {label}
      {required ? (
        <>
          {" "}
          <span style={REQUIRED_ASTERISK_STYLE} aria-hidden="true">
            *
          </span>
        </>
      ) : null}
    </Typography>
  );
}
